import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reduxSlices/userSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
  },
});

export default store;
